{
  "de": {
    "quiz": {
      "correctAnswers": "{count} richtig | {count} richtig",
      "finish": "Fertigstellen",
      "incorrectAnswers": "{count} falsch | {count} falsch",
      "next": "Weiter",
      "resultsTitle": "Quiz Ergebnis",
      "step": "Schritt {current} von {total}",
      "tryAgain": "Nochmal versuchen"
    }
  }
}
